export default "__VITE_ASSET__f813c47a__"